import { ActionTypes } from '../constants/index';

export function getMedias(): Object {
  return {
    type: ActionTypes.GALLERY_GET_REQUEST,
    payload: {},
  };
}

export function pixabaySearch(term: string): Object {
  return {
    type: ActionTypes.GALLERY_PIXABAY_SEARCH_REQUEST,
    payload: { term },
  };
}

export function addFromPixabay(image: Object): Object {
  return {
    type: ActionTypes.GALLERY_ADDFROM_PIXABAY_REQUEST,
    payload: { image },
  };
}

export function usePixabay(): Object {
  return {
    type: ActionTypes.GALLERY_USE_PIXABAY_REQUEST,
  };
}

export function deleteMedia(mediaUrlsafes: Object): Object {
  return {
    type: ActionTypes.GALLERY_DELETE_REQUEST,
    payload: { mediaUrlsafes },
  };
}

export function clickMedia(mediaUrlsafe: string): Object {
  return {
    type: ActionTypes.GALLERY_CLICK_REQUEST,
    payload: { mediaUrlsafe },
  };
}

export function exitSelectMode(): Object {
  return {
    type: ActionTypes.GALLERY_EXIT_SELECT_MODE,
    payload: {},
  };
}

export function changeUploadStatus(change: Object): Object {
  return {
    type: ActionTypes.GALLERY_UPLOAD_STATUS_CHANGE,
    payload: { change },
  };
}



// WEBPACK FOOTER //
// ./scripts/actions/gallery.js